
export default {
    path: "*",
    name: "404",
    meta: { layout: "simple" },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ "./PageNotFound.vue")
};
